<div class="cb-margin-left-3x cb-margin-right-3x cb-margin-bottom-3x flex-col flex">
    <form class="flex-col" #form="ngForm">
        <div class="start-center flex-row">
            <h3 class="mat-headline-6 flex">Schedule Items</h3>
            <mat-slide-toggle
                class="cb-margin-right-2x"
                name="reorderingEnabled"
                [checked]="reorderingEnabled"
                [disabled]="reorderingEnabled"
                (click)="enableReordering()"
            >
                Enable Reordering
            </mat-slide-toggle>
            @if (reorderingEnabled) {
                <button
                    class="header-button cb-margin-right-2x"
                    mat-raised-button
                    (cbClick)="saveOrder()"
                    [throttleTime]="2000"
                    [disabled]="!sortOrderChanged"
                    color="primary"
                >
                    Save Order
                </button>
            }
            @if (reorderingEnabled) {
                <button
                    class="cb-margin-right-2x"
                    mat-raised-button
                    (cbClick)="cancelReordering()"
                    [throttleTime]="2000"
                >
                    Cancel Reordering
                </button>
            }
            @if (!reorderingEnabled) {
                <button
                    class="cb-margin-right-2x"
                    mat-raised-button
                    (click)="newItemClicked()"
                    color="primary"
                >
                    New Schedule Item
                </button>
            }
            <cb-select
                class="cb-margin-right-2x"
                label="Select Tag"
                name="selectTag"
                [(ngModel)]="selectedTag"
                [options]="activeSlotTags"
            >
            </cb-select>
            <button
                mat-raised-button
                class="cb-margin-right-2x"
                (click)="applyTag()"
                color="primary"
                [disabled]="!selectedTag"
            >
                Apply Tag to Item/s
            </button>
            <button mat-raised-button (click)="generateSimReport()" color="primary">
                Generate Report
            </button>
        </div>
        <div class="start-center flex-row">
            @if (!reorderingEnabled) {
                <cb-input
                    class="cb-margin-right-2x flex"
                    type="text"
                    label="Type in Schedule Item Name / Tag to Search"
                    [(ngModel)]="userCacheItem.data.query"
                    name="query"
                >
                </cb-input>
            }
            @if (!reorderingEnabled) {
                <cb-select-list
                    class="cb-margin-right-2x flex"
                    label="Cost Types"
                    [allOptions]="costTypes"
                    [multiple]="true"
                    [(value)]="userCacheItem.data.costTypeId"
                >
                </cb-select-list>
            }
            @if (!reorderingEnabled) {
                <cb-select-list
                    class="cb-margin-right gt-sm-"
                    label="House Areas"
                    [allOptions]="houseAreas"
                    [multiple]="true"
                    (selectChanged)="filteredHouseAreas.recompute()"
                    [(value)]="userCacheItem.data.selectedHouseAreas"
                >
                </cb-select-list>
            }
            @if (!reorderingEnabled) {
                <cb-checkbox
                    label="Active Only"
                    style="height: 30px"
                    class="cb-margin-right-2x"
                    name="activeOnly"
                    [(ngModel)]="userCacheItem.data.isActive"
                >
                </cb-checkbox>
            }
            <span class="flex"></span>
            <button class="cb-margin-bottom-2x" mat-raised-button (click)="expandCollapseAll()">
                @if (!allExpanded) {
                    <span class="start-center flex-row">
                        <span> Expand All&nbsp; </span>
                        <mat-icon> keyboard_arrow_down </mat-icon>
                    </span>
                }
                @if (allExpanded) {
                    <span class="start-center flex-row">
                        <span> Collapse All&nbsp; </span>
                        <mat-icon> keyboard_arrow_up </mat-icon>
                    </span>
                }
            </button>
        </div>
    </form>
    <mat-accordion [multi]="true" class="accordion scroll-container">
        @for (houseArea of filteredHouseAreas.value; track houseArea) {
            <mat-expansion-panel
                [hidden]="allExpanded && !(houseArea?.itemCount > 0)"
                class="panel"
                [(expanded)]="expandedAreas[houseArea.id]"
                (expandedChange)="handleExpandChange(houseArea)"
                (cbOnDestroy)="handlePanelContentsDestroy(houseArea)"
            >
                <mat-expansion-panel-header class="cb-padding-top cb-padding-bottom">
                    <mat-panel-title>
                        <span class="mat-body-strong cb-margin-top">
                            {{ houseArea.label }}
                        </span>
                    </mat-panel-title>
                    <mat-panel-description class="end-center flex-row"> </mat-panel-description>
                </mat-expansion-panel-header>
                @if (expandedAreas[houseArea.id]) {
                    <cb-house-area-slots-table
                        [searchEnabled]="searchEnabled"
                        [queryUpdated]="queryUpdated"
                        [reorderCancelled]="reorderCancelled"
                        [resetSelectedTags]="resetSelectedTags"
                        [reorderingEnabled]="reorderingEnabled"
                        [houseAreaId]="houseArea.id"
                        [slotTags]="slotTags"
                        (sortOrderChanged)="sortOrderChange($event)"
                        (itemSelectedEmitter)="handleListChanged($event)"
                        (parentSlotCountEmitter)="houseArea.itemCount = $event"
                        [slotsUpdated]="slotsUpdated"
                    >
                    </cb-house-area-slots-table>
                }
            </mat-expansion-panel>
        }
    </mat-accordion>
</div>
